var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-from',{attrs:{"fields":_vm.fields,"pagination":_vm.pagination},on:{"click":_vm.onSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }